import { useState } from 'react';
import { Link, Copy, Check, Share2, MessageCircle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "~/components/ui/dialog";
import { Button } from "~/components/ui/button";
import { Separator } from "~/components/ui/separator";

interface ShareDialogProps {
  title: string;
  url: string;
}

export function ShareDialog({ title, url }: ShareDialogProps) {
  const [isCopied, setIsCopied] = useState(false);
  const encodedText = encodeURIComponent(`${title}\n${url}`);
  const whatsappUrl = `https://wa.me/?text=${encodedText}`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text:', err);
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          <Share2 className="h-4 w-4 mr-2" />
          Compartir
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Compartir espacio</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4 py-4">
          <Button
            variant="outline"
            className="flex items-center justify-start gap-2"
            asChild
          >
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              <MessageCircle className="h-4 w-4" />
              Compartir por WhatsApp
            </a>
          </Button>
          <Separator className="my-0.1" />
          <Button
            variant="outline"
            className="flex items-center justify-start gap-2"
            onClick={handleCopyLink}
          >
            {isCopied ? (
              <Check className="h-4 w-4 text-green-500" />
            ) : (
              <Copy className="h-4 w-4" />
            )}
            {isCopied ? "¡Copiado!" : "Copiar enlace"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}